import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Inventory Aging Report";
const description = `The Inventory Aging by Due Date Report (or simply the Open Sales Order by Due Date Report) is a crucial logistics and fulfillment tool used to manage the outbound flow of materials and prioritize picking and packing activities.Unlike a standard financial aging report which tracks how long inventory has been in storage (since the received date), this report focuses on outbound risk and prioritization by measuring the time remaining before an allocated shipment is due.`;

const images = [
    '/images/reports/purchase-by-supplier/purchase-by-supplier.png', // 0
];


const InventoryAgingReport : React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InventoryAgingReport;
